import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';

const SiteMenu = ({ dataSource, onMenuItemClick, selectedKeys }) => {
  const handleMenuItemClick = (e) => {
    const { item } = e;
    onMenuItemClick(item.props['data-item']);
  };

  const renderMenuItem = item => (item.visible() ? (
    <Menu.Item id={`SiteMenu-${item.name}`.replace(/\s+/g, '')} key={item.name} data-item={item}>
      {item.displayName}
    </Menu.Item>
  ) : null);

  return (
    <div className="bhp-site-menu">
      <Menu mode="horizontal" onClick={handleMenuItemClick} selectedKeys={selectedKeys}>
        {dataSource.map(renderMenuItem)}
      </Menu>
    </div>
  );
};

SiteMenu.propTypes = {
  dataSource: PropTypes.array,
  selectedKeys: PropTypes.array,
  onMenuItemClick: PropTypes.func
};

SiteMenu.defaultProps = {
  dataSource: [],
  selectedKeys: [],
  onMenuItemClick() {
  }
};

export default SiteMenu;
